module.exports = __webpack_public_path__ + "static/img/作品33.dea1a14.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/设计市场/作品33.png
// module id = glq4
// module chunks = 1